const Auth = {
  _accessKey: 'ACCESS_TOKEN',
  _refreshKey: 'REFRESH_TOKEN',
  _currentUserKey: 'CURRENT_USER',

  get accessToken() {
    return localStorage.getItem(Auth._accessKey);
  },

  set accessToken(token) {
    localStorage.setItem(Auth._accessKey, token);
  },

  clearAccessToken() {
    localStorage.removeItem(Auth._accessKey); // Changed from `clear` to `removeItem`
  },

  get refreshToken() {
    return localStorage.getItem(Auth._refreshKey);
  },

  set refreshToken(token) {
    localStorage.setItem(Auth._refreshKey, token);
  },

  clearRefreshToken() {
    localStorage.removeItem(Auth._refreshKey); // Changed from `clear` to `removeItem`
  },

  get currentUser() {
    const userString = localStorage.getItem(Auth._currentUserKey);

    // Check if userString exists and is not the string "undefined" or "null"
    if (!userString || userString === 'undefined' || userString === 'null') {
      return null;
    }
    try {
      const parsed = JSON.parse(userString);
      return parsed;
    } catch (e) {
      console.error('Failed to parse currentUser from localStorage:', e);
      return null;
    }
  },

  set currentUser(user) {
    if (user && user !== 'undefined' && user !== 'null') {
      try {
        const jsonString = JSON.stringify(user);
        localStorage.setItem(Auth._currentUserKey, jsonString);
      } catch (e) {
        console.error('Failed to store user:', e);
      }
    }
  },

  clearCurrentUser() {
    localStorage.removeItem(Auth._currentUserKey); // Changed from `clear` to `removeItem`
  },

  clearParams() {
    localStorage.removeItem('careRequestsDetailsViewParams');
  },

  clearVendorData() {
    localStorage.removeItem('CLAIMED_VENDOR');
  },

  logout() {
    Auth.clearAccessToken();
    Auth.clearRefreshToken();
    Auth.clearCurrentUser();
    Auth.clearParams();
    Auth.clearVendorData();
    Auth.clearAuthCookies();
  },

  clearAuthCookies() {
    const cookieNames = ['d_auth_cookie', 'd_auth_cookie_refresh'];
    cookieNames.forEach((name) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=localhost;`;
    });
  },

  // Signup-specific logout method that does NOT clear tokens
  signupLogout() {
    Auth.clearCurrentUser(); // Clear user data, but keep tokens
    Auth.clearParams();
  },

  // Helper method to safely parse JSON from localStorage
  safeGetItem(key, defaultValue = null) {
    try {
      const item = localStorage.getItem(key);
      if (!item || item === 'undefined' || item === 'null') {
        return defaultValue;
      }
      return JSON.parse(item);
    } catch (e) {
      console.warn(`Failed to parse localStorage item "${key}":`, e);
      return defaultValue;
    }
  },
};

export default Auth;
